import { ConfirmationService, MenuItem } from 'primeng/api';
import { AuthUserModel } from 'projects/core/src/lib/models/authuser.model';
import { Component, OnInit } from '@angular/core';
import { DataService } from '../../services/data.service';
import {
  faStreetView,
  faUsers,
  faBars,
  faPowerOff,
  faHome,
  faExpandWide,
  faCompressWide,
  faEdit,
  faUser,
  faExclamationTriangle
} from '@fortawesome/pro-light-svg-icons';
import { AuthStateService } from '../../services/auth-state.service';
import { AcModel } from '../../models/ac.model';
import { TranslocoService } from '@ngneat/transloco';
import { Router } from '@angular/router';
import { AcSelectorModes } from '../ac-selector/ac-selector.component';
import { ApiService } from '../../services/api.service';
import { AppService } from '../../services/app.service';
import { TimingService } from '../../services/timing.service';

@Component({
  selector: 'app-headline',
  templateUrl: './headline.component.html',
  styleUrls: ['./headline.component.scss']
})
export class HeadlineComponent implements OnInit {

  public ac: AcModel = null;
  public user: AuthUserModel = null;
  public clock: any = null;
  public items: Array<MenuItem> = [];
  public changeProcedureVisible = false;
  public changeProcedureAcList: Array<AcModel> = [];
  public changeProcedureLoading = false;

  // icons
  public faStreetView = faStreetView;
  public faUsers = faUsers;
  public faBars = faBars;
  public faPowerOff = faPowerOff;
  public faHome = faHome;
  public faExpandWide = faExpandWide;
  public faCompressWide = faCompressWide;
  public faEdit = faEdit;
  public faUser = faUser;
  public faExclamationTriangle = faExclamationTriangle;

  public AcSelectorModes = AcSelectorModes;

  constructor(
    private router: Router,
    private app: AppService,
    private api: ApiService,
    private timing: TimingService,
    private confirmation: ConfirmationService,
    public data: DataService,
    public auth: AuthStateService,
    public transloco: TranslocoService
  ) { }

  ngOnInit(): void {
    this.auth.user$.subscribe((user: AuthUserModel) => this.user = user);
    this.data.ac$.subscribe((ac: AcModel) => this.ac = ac);
    this.timing.clock$.subscribe((clock: any) => this.clock = clock);
    this.buildMenu();
  }

  toggleLanguage(): void {
    if (this.transloco.getActiveLang() === 'en') {
      this.transloco.setActiveLang('de');
    } else {
      this.transloco.setActiveLang('en');
    }
  }

  logout(): void {
    this.confirmation.confirm({
      message: this.transloco.translate('partials.headline.messages.really_logout'),
      header: this.transloco.translate('partials.headline.labels.logout'),
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'pi pi-check',
      acceptLabel: this.transloco.translate('common.labels.yes'),
      rejectIcon: 'pi pi-times',
      rejectLabel: this.transloco.translate('common.labels.no'),
      accept: () => {
        this.auth.logout();
      }
    });
  }

  openFullScreen(): void {
    const elem: any = document.documentElement;
    const methodToBeInvoked = elem.requestFullscreen ||
      elem.webkitRequestFullScreen || elem.mozRequestFullscreen || elem.msRequestFullscreen;
    if (methodToBeInvoked) {
      methodToBeInvoked.call(elem);
    }
  }

  closeFullScreen(): void {
    const elem: any = document;
    const methodToBeInvoked = elem.exitFullscreen ||
      elem.webkitExitFullscreen || elem.mozCancelFullScreen || elem.msExitFullscreen;
    if (methodToBeInvoked) {
      methodToBeInvoked.call(elem);
    }
  }

  isFullScreen(): boolean {
    const elem: any = document;
    return !!(elem.fullscreenElement || elem.mozFullScreenElement || elem.webkitFullscreenElement || elem.msFullscreenElement);
  }

  showChangeAc(): void {
    this.changeProcedureVisible = true;
    this.changeProcedureLoading = true;
    this.api.aclistWithToken().subscribe({
      next: (result: any) => {
        this.changeProcedureAcList = [];
        result.data.forEach((ac: any) => {
          this.changeProcedureAcList.push(new AcModel().deserialize(ac, false));
        });
      }
    }).add(() => {
      this.changeProcedureLoading = false;
    });
  }

  hideChangeAc(): void {
    this.changeProcedureVisible = false;
  }

  selectAc(ac: AcModel): void {
    this.api.changeAc(ac.id).subscribe({
      next: (result: any) => {
        this.auth.login(result.access_token, '/ac/dashboard');
        this.app.loadAc();
      }
    }).add(() => {
      this.hideChangeAc();
    });
  }

  gotoChangePassword(): void {
    this.router.navigate(['/ac/password-change']);
  }

  private buildMenu(): void {
    if (this.auth.isModerator()) {
      this.items.push({
        label: this.transloco.translate('partials.headline.change_password'),
        // icon: 'pi pi-copy',
        command: () => {
          this.gotoChangePassword();
        }
      });
      this.items.push({
        label: this.transloco.translate('partials.headline.change_ac'),
        // icon: 'pi pi-copy',
        command: () => {
          this.showChangeAc();
        }
      });
    }
    this.items.push({
      label: this.transloco.translate('partials.headline.info'),
      // icon: 'pi pi-trash',
      command: () => {
        this.app.showSplashScreen();
      }
    });
    this.items.push({
      label: this.transloco.translate('partials.headline.logout'),
      // icon: 'pi pi-trash',
      command: () => {
        this.logout();
      }
    });
  }

}
